module.exports = "/_next/static/images/baller-piece-out-4ea9aa23874e48af8c2f8679fa8c4600.png";